import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 text-center text-slate-100">
      <div className="rounded-3xl border border-slate-900 bg-slate-900/60 px-8 py-10 shadow-xl">
        <p className="text-sm uppercase tracking-[0.3em] text-slate-500">404</p>
        <h1 className="mt-3 text-3xl font-semibold">Page not found</h1>
        <p className="mt-2 text-sm text-slate-400">
          The page you are looking for doesn&apos;t exist. Let&apos;s get you back to the chat workspace.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-full border border-slate-700 px-5 py-2 text-sm font-semibold text-slate-200 transition hover:border-sky-500 hover:text-white"
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
